const getOwlCarousel = () => import(/* webpackChunkName: "get-owl-carousel" */ 'owl.carousel');

const addAccessibilityAttributes = (elem) => {
	setTimeout(() => {
		const owlDots = elem.find('.owl-dot');
		owlDots.each(function(index) { 
			rp$(this).attr('aria-label', `Go to slide ${index + 1}`);
		});
        
		elem.find('.owl-prev').attr('aria-label', 'Previous slide');
		elem.find('.owl-next').attr('aria-label', 'Next slide');
		
		elem.find('.owl-item').each(function() {
			const $owlItem = rp$(this);
			const $li = $owlItem.find('li');
			
			if ($li.length > 0) {
				const $div = rp$('<div></div>').html($li.html());
				rp$.each($li[0].attributes, function() {
					$div.attr(this.name, this.value);
				});
				$li.replaceWith($div);
				$owlItem.attr('role', 'listitem');
			}
		});
		
		elem.find('img').each(function() {
			const $img = rp$(this);
			if (!$img.attr('alt')) {
				$img.attr('alt', 'Carousel image');
			}
		});
	}, 100);
};

const handleOwlCarouselModule = ({elem, options}) => {
	getOwlCarousel().then(() => {
		elem.owlCarousel(options); 
		addAccessibilityAttributes(elem);
		elem.on('refreshed.owl.carousel', function() {
			addAccessibilityAttributes(elem);
		});
		elem.on('changed.owl.carousel', function() {
			addAccessibilityAttributes(elem);
		});
	});
};

//This is just intercept calls to start a carousels, we will rerun these after the owl carousel is fully loaded.
//This will be replaced with the actual owl carousel once it loads.
rp$.fn.owlCarousel = function(options) {
	handleOwlCarouselModule({elem: this, options});
};
